import { Injectable } from '@angular/core';
import Notiflix from 'notiflix';
import { AppConfigService } from 'src/app/config/app.config.service';

@Injectable({
  providedIn: 'root'
})
export class CommunService {
  bcCoreApiUrl = AppConfigService.settings.bcCoreApiUrl;
  customApiUrlSegment = AppConfigService.settings.customApiUrlSegment;
  bcEnvirName = AppConfigService.settings.bcEnvirName;
  defaultLg = AppConfigService.settings.defaultLanguage;

  userAccess = {
    create: true, read: true, update: true, delete: true 
  }

  roleEnglishToFrench = {
    Mechanic: 'Mécanicien',
    Evaluator: 'Evaluateur',
    Supervisor: 'Superviseur',
    Administrator: 'Administrateur'
  }

  notifyConfig = {
    timeout: 20000,
    showOnlyTheLastOne: true, 
    width: "auto",
    messageMaxLength: 5000,
    clickToClose: true
  }

  private readonly GENERIC_ERROR_MESSAGE = "Une erreur s'est produite pendant le traitement. Veuillez réessayer";
  private readonly GENERIC_WARNING_MESSAGE = "Une attention particulière est requise. Veuillez vérifier les informations saisies";
  private readonly GENERIC_INFO_MESSAGE = "Aucune information complémentaire n'est disponible";
  public readonly GENERIC_SUCCESS_MESSAGE = "L'opération a été effectuée avec succès";

  generateRandomCode() {
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    const lengthOfCode = 6;
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
      return text;
  }
  
  openPdfFileInNewTab(fileBase64, ){
      var byteCharacters = atob(fileBase64);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL); 
  }

  initNotiflix(){
    Notiflix.Notify.init({
      position: 'right-bottom'
    });

    Notiflix.Confirm.init({
      width: '450px',
      okButtonBackground: '#04B76B',
      cancelButtonBackground: '#FF5E6D',
      titleColor: '#392C70',
      borderRadius: '5px',
      backgroundColor: '#ffffff',
    });
  }

  showLoading(): void {
    Notiflix.Loading.standard('Chargement...', {
      svgColor: '#ffffff'
    });
  }

  notifyFailure(message){
    Notiflix.Notify.failure(message ?? this.GENERIC_ERROR_MESSAGE, this.notifyConfig)
  }

  notifyWarning(message){
    Notiflix.Notify.warning(message ?? this.GENERIC_WARNING_MESSAGE, this.notifyConfig)
  }

  notifyInfo(message){
    Notiflix.Notify.info(message ?? this.GENERIC_INFO_MESSAGE, this.notifyConfig)
  }

  notifySuccess(message){
    Notiflix.Notify.success(message ?? this.GENERIC_SUCCESS_MESSAGE, this.notifyConfig)
  }
}
